import { createSlice } from '@reduxjs/toolkit';
import { ContactSubmission } from '../interface/contact.interface';
import { submitContactForm } from '../thunks/contact.thunk';

interface ContactState {
  isSubmitting: boolean;
  isSubmitted: boolean;
  lastSubmission: ContactSubmission | null;
  error: string | null;
}

const initialState: ContactState = {
  isSubmitting: false,
  isSubmitted: false,
  lastSubmission: null,
  error: null,
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    resetContactState: () => initialState,
    clearContactError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.isSubmitting = true;
        state.isSubmitted = false;
        state.error = null;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.isSubmitted = true;
        state.lastSubmission = action.payload;
        state.error = null;
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.isSubmitting = false;
        state.isSubmitted = false;
        state.error = (action.payload as string) || 'Failed to send your message.';
      });
  },
});

export const { resetContactState, clearContactError } = contactSlice.actions;
export default contactSlice.reducer;
